import {NgModule} from '@angular/core';
import {JsonCodecService} from './json-codec.service';
import {SessionWebsocketService} from './session-websocket.service';
import {WebsocketClientService} from './websocket-client.service';

@NgModule({
    providers: [
        JsonCodecService,
        SessionWebsocketService,
        WebsocketClientService
    ]
})
export class DexApiModule {}
